/**
 * @ngdoc directive
 * @name directiveSelectDate
 * @restrict A
 *
 * @description
 * Directive for advanced search.
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {},
        controller: 'directiveSelectDateCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/selectDate.js